module.exports = __webpack_public_path__ + "static/media/bg.e5241971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = 239
// module chunks = 0